/** Zahlen, Daten und Kennungen so, wie eine Kanzlei sie liest. */

export function euro(cent: string | bigint | null | undefined, mitVorzeichen = false): string {
  if (cent === null || cent === undefined || cent === '') return '—'
  const wert = typeof cent === 'bigint' ? cent : BigInt(cent)
  const negativ = wert < 0n
  const abs = negativ ? -wert : wert
  const ganz = (abs / 100n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  const rest = (abs % 100n).toString().padStart(2, '0')
  const zeichen = negativ ? '−' : mitVorzeichen ? '+' : ''
  return `${zeichen}${ganz},${rest}`
}

export function datum(iso: string | null | undefined): string {
  if (!iso) return '—'
  const [j, m, t] = iso.slice(0, 10).split('-')
  return `${t}.${m}.${j}`
}

export function zeitpunkt(iso: string | null | undefined): string {
  if (!iso) return '—'
  return new Date(iso).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
}

export function zeitraum(von: string | null | undefined, bis: string | null | undefined): string {
  if (!von && !bis) return 'Zeitraum fehlt'
  return `${datum(von)} bis ${datum(bis)}`
}

export function iban(wert: string | null | undefined): string {
  if (!wert) return '—'
  return wert.replace(/(.{4})/g, '$1 ').trim()
}

export const STAND_TEXT: Record<string, string> = {
  pruefen: 'zu prüfen',
  bereit: 'bereit',
  freigegeben: 'freigegeben',
  doppelt: 'doppelt',
  exportiert: 'exportiert',
  wartet: 'wartet',
  wird_gelesen: 'wird gelesen',
  fehler: 'Fehler',
}

/**
 * Eine Kontokennung lesbar, wie auf dem Server (kennungLesbar): Girokonto als
 * IBAN in Viererblöcken, Kreditkarte ohne eigene IBAN als "AMEX, Karte endet auf 1234".
 */
export function kennungLesbar(kennung: string | null | undefined): string {
  if (!kennung) return '—'
  if (!kennung.startsWith('KARTE:')) return iban(kennung)
  const [, anbieter, ziffern] = kennung.split(':')
  return `${anbieter}, Karte endet auf ${ziffern}`
}

/** Das Konto eines Auszugs: bei der Kartenabrechnung die maskierte Kartennummer statt der IBAN. */
export function kontoVonAuszug(a: {
  dokumenttyp?: 'kontoauszug' | 'kreditkartenabrechnung'
  iban: string | null
  kontokennung?: string | null
  kartennummer_maskiert?: string | null
  kartenanbieter?: string | null
}): string {
  if (a.dokumenttyp !== 'kreditkartenabrechnung') return iban(a.iban)
  // Kurz, damit die Spalte so schmal bleibt wie eine IBAN. Der Anbieter steht schon unter dem Titel.
  const ziffern = (a.kartennummer_maskiert ?? '').match(/(\d{4})\D*$/)?.[1] ?? (a.kontokennung?.startsWith('KARTE:') ? a.kontokennung.split(':')[2] : undefined)
  if (ziffern) return `Karte •••• ${ziffern}`
  return iban(a.iban)
}

export const FORMAT_TEXT: Record<string, string> = {
  camt053: 'camt.053',
  mt940: 'MT940',
  datev_extf: 'DATEV-Buchungsstapel',
}
